"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _kendoReactGrid = require("@progress/kendo-react-grid");

var _FoxButton = _interopRequireDefault(require("../FoxButton"));

var _pl = _interopRequireDefault(require("./pl.json"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var propTypes = {
  columns: _propTypes.default.any.isRequired,
  onColumnsSubmit: _propTypes.default.func.isRequired,
  onCloseMenu: _propTypes.default.func.isRequired
};
var defaultProps = {};

var FoxGridColumnMenu = /*#__PURE__*/function (_PureComponent) {
  _inherits(FoxGridColumnMenu, _PureComponent);

  function FoxGridColumnMenu(props) {
    var _this;

    _classCallCheck(this, FoxGridColumnMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FoxGridColumnMenu).call(this, props));
    _this.state = {
      columns: _this.props.columns,
      columnsExpanded: false,
      filterExpanded: false
    };
    _this.onToggleColumn = _this.onToggleColumn.bind(_assertThisInitialized(_this));
    _this.onReset = _this.onReset.bind(_assertThisInitialized(_this));
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    _this.onMenuItemClick = _this.onMenuItemClick.bind(_assertThisInitialized(_this));
    _this.onFilterExpandChange = _this.onFilterExpandChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FoxGridColumnMenu, [{
    key: "onToggleColumn",
    value: function onToggleColumn(id) {
      this.setState({
        columns: this.state.columns.map(function (column, index) {
          return index === id ? _objectSpread({}, column, {
            props: _objectSpread({}, column.props, {
              hidden: !column.props.hidden
            })
          }) : column;
        })
      });
    }
  }, {
    key: "onReset",
    value: function onReset(event) {
      var _this2 = this;

      event.preventDefault();
      var allColumns = this.props.columns.map(function (column) {
        return _objectSpread({}, column, {
          hidden: false
        });
      });
      this.setState({
        columns: allColumns
      }, function () {
        return _this2.onSubmit();
      });
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(event) {
      if (event) {
        event.preventDefault();
      }

      this.props.onColumnsSubmit(this.state.columns);

      if (this.props.onCloseMenu) {
        this.props.onCloseMenu();
      }
    }
  }, {
    key: "onMenuItemClick",
    value: function onMenuItemClick() {
      var value = !this.state.columnsExpanded;
      this.setState({
        columnsExpanded: value,
        filterExpanded: value ? false : this.state.filterExpanded
      });
    }
  }, {
    key: "onFilterExpandChange",
    value: function onFilterExpandChange(value) {
      this.setState({
        filterExpanded: value,
        columnsExpanded: value ? false : this.state.columnsExpanded
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react.default.createElement("div", null, _react.default.createElement(_kendoReactGrid.GridColumnMenuSort, this.props), _react.default.createElement(_kendoReactGrid.GridColumnMenuFilter, _extends({}, this.props, {
        onExpandChange: this.onFilterExpandChange,
        expanded: this.state.filterExpanded
      })), _react.default.createElement(_kendoReactGrid.GridColumnMenuItemGroup, null, _react.default.createElement(_kendoReactGrid.GridColumnMenuItem, {
        title: "Columns",
        iconClass: "k-i-columns",
        onClick: this.onMenuItemClick
      }), _react.default.createElement(_kendoReactGrid.GridColumnMenuItemContent, {
        show: this.state.columnsExpanded
      }, _react.default.createElement("div", {
        className: "k-column-list-wrapper"
      }, _react.default.createElement("form", {
        onSubmit: this.onSubmit,
        onReset: this.onReset
      }, _react.default.createElement("div", {
        className: "k-column-list"
      }, this.state.columns.map(function (column, index) {
        return _react.default.createElement("div", {
          key: index,
          className: "k-column-list-item"
        }, _react.default.createElement("span", null, _react.default.createElement("input", {
          id: "column-visiblity-show-".concat(index),
          className: "k-checkbox",
          type: "checkbox",
          readOnly: true,
          checked: !column.props.hidden,
          onClick: function onClick() {
            _this3.onToggleColumn(index);
          }
        }), _react.default.createElement("label", {
          htmlFor: "column-visiblity-show-".concat(index),
          className: "k-checkbox-label",
          style: {
            userSelect: 'none'
          }
        }, column.props.title)));
      })), _react.default.createElement("div", {
        className: "k-columnmenu-actions"
      }, _react.default.createElement(_FoxButton.default, {
        type: "reset"
      }, _pl.default.grid.reset), _react.default.createElement(_FoxButton.default, {
        primary: true
      }, _pl.default.grid.save)))))));
    }
  }]);

  return FoxGridColumnMenu;
}(_react.PureComponent);

FoxGridColumnMenu.propTypes = propTypes;
FoxGridColumnMenu.defaultProps = defaultProps;
var _default = FoxGridColumnMenu;
exports.default = _default;